<section class="blog-section">
    <div class="container">
        <div class="section-header">
            <h2 class="section-title">Blog onLygal</h2>
            <a class="section-link" (click)="verTodos()">Ver todos los artículos &#x2192;</a>
        </div>
        <div class="blog-grid">
            <article class="blog-card" *ngFor="let articulo of items" (click)="irA(articulo)">
                <div class="blog-image"
                     [class.blog-placeholder]="!imagenUrl(articulo)"
                     [ngStyle]="imagenUrl(articulo) ? { 'background-image': 'url(' + imagenUrl(articulo) + ')' } : null"></div>
                <div class="blog-body">
                    <span class="tag tag-light-blue">{{ articulo.categoria }}</span>
                    <h3 [innerHTML]="articulo.titulo"></h3>
                    <p class="blog-desc">{{ plainDesc(articulo) }}</p>
                </div>
            </article>
        </div>
    </div>
</section>
